import { call, put } from 'redux-saga/effects';

import { getPedidos } from '../../components/listaPedido/api';

import { Creators as pedidosActions } from '../ducks/pedidos';

// O * identifica um generator assim como async, e o yield é um await
function* searchPedidos(action) {
    const { payload } = action,
        { idStatusPedido } = payload,
        list = yield call(getPedidos, idStatusPedido);

    yield put(pedidosActions.addPedidos({ list }));
}

export { searchPedidos };
